import { Util,Request } from "@xt/xtbase";
const { getOrigin } = Util;
const { XtAxios } = Request;

const URL = getOrigin("www") + "/";

//U本位全交易对行情
export function get_fapiTickers(config) {
  return XtAxios.get(URL + `fapi/market/v1/public/q/tickers`, config);
}

//币本位全交易对行情
export function get_dapiTickers(config) {
  return XtAxios.get(URL + `dapi/market/v1/public/q/tickers`, config);
}

//自选收藏，列表
export function get_fapiCollectionList(config) {
  return XtAxios.get(URL + `fapi/user/v1/user/collection/list`, config);
}

//自选收藏，添加
export function post_fapiCollectionAdd(config) {
  return XtAxios.post(URL + `fapi/user/v1/user/collection/add`, null, {...config,headers:{'Content-Type':'application/x-www-form-urlencoded'}});
}

//自选收藏，取消
export function post_fapiCollectionCancel(config) {
  return XtAxios.post(URL + `fapi/user/v1/user/collection/cancel`, null, {...config,headers:{'Content-Type':'application/x-www-form-urlencoded'}});
}

//U本位市场列表
export function get_fapiSymbolList(config) {
  return XtAxios.get(URL + `fapi/market/v1/public/symbol/list`, config);
}

//币本位市场列表
export function get_dapiSymbolList(config) {
  return XtAxios.get(URL + `dapi/market/v1/public/symbol/list`, config);
}

//U本位kline
export function get_fapiKline(config) {
  return XtAxios.get(URL + `fapi/market/v1/public/q/kline`, config);
}
//板块列表
export function get_fapiPlateList(config) {
  return XtAxios.get(URL + `fapi/market/v1/public/plate/list`, config);
}
